import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../Menus/EditCloneDeleteMenu";


export const DataPointXrefGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',
        sortable: true,
        width: 100,
    },
    {
        field: 'dataPointId',
        headerName: 'Data Point ID',
        sortable: true,
        hide: false,
        // editable: true,
        width: 130,
    },
    {
        field: 'dataPointName',
        headerName: 'Data Point',
        sortable: true,
        // editable: true,
        width: 400,
    },

    {
        field: 'attributeId',
        headerName: 'Attribute ID',
        sortable: true,
        // editable: true,
        width: 130,
    },
    {
        field: 'attributeName',
        headerName: 'Attribute',
        sortable: true,
        // editable: true,
        width: 350,
    },
    {
        field: 'category',
        headerName: 'Category',
        sortable: true,
        // editable: true,
        width: 200,
    },
    {
        field: 'ordinalNumber',
        headerName: 'Order',
        sortable: true,
        // editable: true,
        width: 100,
    },
];
